/**
 * Asynchronously loads the component for SignUpPage
 */

import * as React from 'react';
import { lazyLoad } from 'utils/loadable';
import { LoadingIndicator } from 'app/components/LoadingIndicator';

export const UserAdminUpdatePage = lazyLoad(
  () => import('./Prefiller'),
  module => module.Prefiller,
  {
    fallback: <LoadingIndicator />,
  },
);
